import { render, staticRenderFns } from "./LegacySnapshotDetailsForm.vue?vue&type=template&id=6b8386e2"
import script from "./LegacySnapshotDetailsForm.vue?vue&type=script&lang=js"
export * from "./LegacySnapshotDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports